import { Modal } from 'antd';

const DEFAULT_WIDTH = 560;

/**
 * Large centered confirm dialog for destructive / irreversible actions.
 * Prefer this over Popconfirm inside table action Dropdown menus.
 */
export function confirmAction({
  title,
  content,
  description,
  onOk,
  okText,
  cancelText,
  danger = false,
  width = DEFAULT_WIDTH,
  okButtonProps,
  ...rest
} = {}) {
  return Modal.confirm({
    title,
    content: content ?? description,
    onOk,
    okText,
    cancelText,
    centered: true,
    width,
    okButtonProps: danger ? { danger: true, ...okButtonProps } : okButtonProps,
    ...rest,
  });
}

export default confirmAction;
